import * as Sentry from "@sentry/react";

import Routes from "./routes/Routes";

function App() {
  return <Routes />;
}

// enable performance monitoring in Sentry dashboard
export default Sentry.withProfiler(App);
